import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as S from "./style";
import { FaAngleDown } from "react-icons/fa";
import { FaAngleUp } from "react-icons/fa";

function MobileFooterMain() {
  const history = useHistory();
  const { dataCategoriesTerm } = useSelector(
    (state: any) => state.dataCategoriesTerm
  );
  const [isExpanded, setIsExpanded] = useState<boolean>(true);
  const footerRef = useRef<HTMLDivElement>(null);

  const handleExpand = () => {
    setIsExpanded((prev) => !prev);

    if (footerRef.current) {
      const scrollToBottom = () => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        });
      };

      scrollToBottom();

      const resizeObserver = new ResizeObserver(() => {
        scrollToBottom();
      });

      resizeObserver.observe(footerRef.current);

      return () => {
        if (footerRef.current) {
          resizeObserver.unobserve(footerRef.current);
        }
      };
    }
  };

  return (
    <S.Wrapper id="footer" ref={footerRef}>
      <S.Container>
        <div className="footer-title" onClick={handleExpand}>
          COMPANY
          <div className="expand-button">
            {isExpanded ? <FaAngleUp /> : <FaAngleDown />}
          </div>
        </div>
        <S.CollapseWrapper isExpanded={isExpanded}>
          <div className="step1">
            <S.Box>
              <div className="item">
                <span className="value">(주)열매컴퍼니</span>
              </div>
              <div className="item">
                <span className="key">대표자 </span>
                <span className="value">김재욱</span>
              </div>
            </S.Box>
            <S.SubBox>
              <div className="title">주소</div>
              <div className="item">
                <span className="key">서울 </span>
                <span className="value">
                  06182 서울 강남구 영동대로 407, 코니빌딩 4층
                </span>
              </div>
              <div className="item">
                <span className="key">충남 </span>
                <span className="value">
                  31470 충남 아산시 배방읍 희망로46번길 45-11, 405호
                </span>
              </div>
            </S.SubBox>
            <S.SubBox>
              <div className="item">
                <span className="key">통신판매업 신고번호</span>
                <span className="value">2021-충남아산-0558호</span>
              </div>
              <div className="item">
                <span className="key">개인정보관리책임자</span>
                <span className="value">김재욱</span>
              </div>
              <div className="item">
                <span className="key">사업자등록번호</span>
                <span className="value">664-88-00573</span>
              </div>
            </S.SubBox>
          </div>
          <div className="step2">
            <S.Title>CONTACT</S.Title>
            <S.SubBox>
              <div className="item">
                <span className="key">Company Mail (사업제휴 / 회사문의) </span>
                <span className="value">info@artnguide.com</span>
              </div>
              <div className="item">
                <span className="key">CS Mail (고객 CS문의)</span>
                <span className="value">cs@artnguide.com</span>
              </div>
              <div className="item">
                <span className="value">
                  070-5015-0772 (주말 및 공휴일에는 상담이 어렵습니다)
                </span>
              </div>
              <div className="item">
                <div className="key">운영시간 </div>
              </div>
              <div className="item">
                <span className="value">
                  평일 10:00 ~ 18:00 (점심시간 12:00~13:00)
                </span>
              </div>
            </S.SubBox>
          </div>
        </S.CollapseWrapper>
      </S.Container>
      <S.ContainerTerm>
        <div className="container-term-list">
          <div className="item">
            {dataCategoriesTerm?.map((dt: any, i: any) => (
              <div className="term">
                <div key={i} onClick={() => history.push(dt.location)}>
                  {dt.title}
                </div>
                {i !== dataCategoriesTerm.length - 1 ? <div>|</div> : <></>}
              </div>
            ))}
          </div>
          <div className="right">© Yeolmaecompany. all rights reserved</div>
        </div>
      </S.ContainerTerm>
    </S.Wrapper>
  );
}

export default MobileFooterMain;
